import { useState } from "react";
import { Store } from "lucide-react";
import { money } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const VendorPicker = ({ rows, selected, setSelected }) => {
  const [q, setQ] = useState("");
  const groups = {};
  rows.forEach((r) => {
    const g = (groups[r.vendor || "(no vendor)"] ||= { ids: [], total: 0 });
    g.ids.push(r.id);
    g.total += r.amount || 0;
  });
  const vendors = Object.entries(groups)
    .filter(([v]) => v.toLowerCase().includes(q.toLowerCase()))
    .sort((a, b) => a[0].localeCompare(b[0]));

  const toggle = (ids, on) => setSelected((s) => {
    const n = new Set(s);
    ids.forEach((id) => (on ? n.add(id) : n.delete(id)));
    return n;
  });

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" data-testid="vendor-picker-btn" className="rounded-md">
          <Store className="h-4 w-4 mr-2" /> Select by vendor
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-96 p-0 bg-white">
        <div className="p-3 border-b border-slate-100">
          <Input data-testid="vendor-picker-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search vendors" className="rounded-md" />
        </div>
        <div className="max-h-80 overflow-y-auto divide-y divide-slate-50" data-testid="vendor-picker-list">
          {vendors.length === 0 && <p className="p-4 text-sm text-slate-400">No vendors.</p>}
          {vendors.map(([v, g]) => {
            const all = g.ids.every((id) => selected.has(id));
            return (
              <label key={v} className="flex items-center gap-3 px-3 py-2 text-sm cursor-pointer hover:bg-slate-50" data-testid={`vendor-option-${v}`}>
                <Checkbox checked={all} onCheckedChange={(c) => toggle(g.ids, !!c)} />
                <span className="flex-1 truncate text-slate-800">{v}</span>
                <span className="text-xs text-slate-400 tabular-nums">{g.ids.length} · {money(g.total)}</span>
              </label>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
};
